import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  cashBalance: [],
  addData: {},
  sorted: [],
};

const slice = createSlice({
  name: 'Expense',
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    getExpensesSuccess(state, action) {
      state.data = action.payload.data;
    },

    getPreviousCashBalanceSuccess(state, action) {
      state.cashBalance = action.payload.data;
    },

    addOrUpdateExpenses(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getExpenses(locationId, isTransfer = false) {
  return async () => {
    try {
      const response = await get(`Expense?locationId=${locationId}&isTransfer=${isTransfer}`);
      if (response.status) {
        dispatch(slice.actions.getExpensesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getExpensesByStatus(status) {
  return async () => {
    try {
      const response = await get(`getExpensesByStatus?status=${status}`);
      if (response.status) {
        dispatch(slice.actions.getExpensesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPreviousCashBalance(locationId, date) {
  return async () => {
    try {
      const response = await get(`previousCashBalance?locationId=${locationId}&date=${date}`);
      if (response.status) {
        dispatch(slice.actions.getPreviousCashBalanceSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getForPaymentDateRange(locationId, startDate, endDate, isTransfer = false) {
  return async () => {
    try {
      const response = await get(`getForPaymentDateRange?locationId=${locationId}&isTransfer=${isTransfer}&startDate=${startDate}&endDate=${endDate}`);
      if (response.status) {
        dispatch(slice.actions.getExpensesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addExpenses(body) {
  return async () => {
    try {
      const response = await post(`Expense`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateExpenses(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateExpenses(body) {
  return async () => {
    try {
      const response = await put(`Expense`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateExpenses(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
